import { Update } from '@ngrx/entity'
import { createAction, props } from '@ngrx/store'
import { ActivityFeedPostsEntity } from './activity-feed-posts.models'
import { ItemEntity } from 'libs/gb-front/selected-item/data-access/src/lib/+state/selected-item.models'
import { HttpErrorResponse } from '@angular/common/http'

export const initActivityFeedPosts = createAction('[ActivityFeedPosts/API] Init Activity Feed Posts')
export const initActivityFeedPostsFailure = createAction(
  '[ActivityFeedPosts/API] Init Activity Feed Posts Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadActivityFeedPosts = createAction('[ActivityFeedPosts/API] Load Activity Feed Posts')

export const setActivePage = createAction('[ActivityFeedPosts/Page] set active page', props<{ pageNumber: number }>())

export const loadNextActivityFeedPosts = createAction(
  '[ActivityFeedPosts/API] Load Next Activity Feed Posts',
  props<{ offset: number }>(),
)

export const resyncActivityFeedPosts = createAction('[ActivityFeedPosts/API] Resync activity feed posts')

export const updateActivityFeedPosts = createAction(
  '[ActivityFeedPosts/API] Update Actvity Feed Posts',
  props<{ activityFeedPosts: Update<ActivityFeedPostsEntity>[] }>(),
)

export const resyncActivityFeedPostsError = createAction(
  '[ActivityFeedPosts/API] resync Activity Feed Post Error',
  props<{ error: HttpErrorResponse }>(),
)

export const loadActivityFeedPostsSuccess = createAction(
  '[ActivityFeedPosts/API] Load ActivityFeedPosts Success',
  props<{
    activityFeedPosts: ActivityFeedPostsEntity[]
    next: string | null
  }>(),
)

export const loadNextActivityFeedPostsSuccess = createAction(
  '[ActivityFeedPosts/API] Load Next ActivityFeedPosts Success',
  props<{
    activityFeedPosts: ActivityFeedPostsEntity[]
  }>(),
)
export const loadNextActivityFeedPostsFailure = createAction(
  '[ActivityFeedPosts/API] Load Next ActivityFeedPosts Failure',
  props<{
    error: HttpErrorResponse
  }>(),
)

export const updateActivityFeedPostsNextUrl = createAction('[ActivityFeedPosts/API] Update next')
export const updateActivityFeedPostsNextUrlSuccess = createAction(
  '[ActivityFeedPosts/API] Update next Success',
  props<{
    next: string | null
  }>(),
)

export const updateActivityFeedPostsNextUrlsFailure = createAction(
  '[ActivityFeedPosts/API] Update next Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const loadActivityFeedPostsFailure = createAction(
  '[ActivityFeedPosts/API] Load ActivityFeedPosts Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const createActivityFeedPost = createAction(
  '[ActivityFeedPosts/API] Create activity feed post',
  props<{ message: string; onSuccess?: () => void }>(),
)

export const createActivityFeedPostItem = createAction(
  '[ActivityFeedPosts/API] Create activity feed post item',
  props<{
    message: string
    item: ItemEntity
    onSuccess?: () => void
  }>(),
)

export const createActivityFeedPostSuccess = createAction(
  '[ActivityFeedPosts/API] Create activity feed post success',
  props<{
    activityFeedPost: ActivityFeedPostsEntity
    openActivityFeed?: boolean
    onSuccess?: () => void
  }>(),
)

export const addOneActivityFeedPost = createAction(
  '[ActivityFeedPosts/Page] Add one activity feed post',
  props<{ data: ActivityFeedPostsEntity }>(),
)

export const addOneActivityFeedPostReply = createAction('[ActivityFeedPosts/Page] Add one activity feed post reply')

export const addNewActivityFeedPost = createAction(
  '[ActivityFeedPosts/Page] Add new activity feed post',
  props<{ data: ActivityFeedPostsEntity }>(),
)

export const createActivityFeedPostFailure = createAction(
  '[ActivityFeedPosts/API] Create activity feed post failure',
  props<{ error: HttpErrorResponse }>(),
)

export const deleteActivityFeedPost = createAction(
  '[ActivityFeedPosts/API] Delete activity feed post',
  props<{ activityFeedPostUuid: string }>(),
)

export const deleteActivityFeedPostSuccess = createAction('[ActivityFeedPosts/API] Delete activity feed post Success')

export const deleteActivityFeedPostFailure = createAction(
  '[ActivityFeedPosts/API] Delete activity feed post Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const startPostProcess = createAction(
  '[ActivityFeedPosts/API] Start post process',
  props<{
    message: string
    parentPost?: string
    item?: ItemEntity
    onSuccess?: () => void
  }>(),
)

export const createActivityFeedReply = createAction(
  '[ActivityFeedPosts/API] Create activity feed reply',
  props<{
    message: string
    parentPost: string
    onSuccess?: () => void
  }>(),
)

export const createActivityFeedReplySuccess = createAction(
  '[ActivityFeedPosts/API] Create activity feed post reply',
  (onSuccess?: () => void) => ({ onSuccess }),
)

export const createActivityFeedReplyFailure = createAction(
  '[ActivityFeedPosts/API] Create activity feed post reply',
  props<{ error: HttpErrorResponse }>(),
)

export const updateCount = createAction('[ActivityFeedPosts/Page] Update Count', props<{ count: number }>())

export const loadMoreReplies = createAction(
  '[ActivityFeedPosts/API] Load Next Replies',
  props<{ activityFeedPostUuid: string; limit: number }>(),
)
export const loadNextActivityFeedRepliesSuccess = createAction(
  '[ActivityFeedPosts/API] Load Next Replies success',
  props<{ update: Update<ActivityFeedPostsEntity> }>(),
)
export const loadNextActivityFeedRepliesFailure = createAction(
  '[ActivityFeedPosts/API] Load Next Replies failure',
  props<{ error: HttpErrorResponse }>(),
)
